<div [ngClass]="isPopup ? 'p-5 ' : 'max-width-container px-6 xl:px-[100px] md:px-[6.9%] mb-20 md:pb-7 mt-10'">
    <h1 class="text-3xl font-semibold text-center mb-10">{{ title | translate }}</h1>

    <div *ngIf="isLoading; else content">
        <div class="animate-pulse rounded-xl space-y-6">
            <div class="loader h-10 w-full rounded-xl"></div>
            <div class="loader h-10 w-full rounded-xl"></div>
            <div class="loader h-10 w-full rounded-xl"></div>
            <div class="loader h-10 w-full rounded-xl"></div>
        </div>
    </div>

    <ng-template #content>
        <div *ngIf="documentContent; else noResults">
            <div class="rich-text-container" [innerHTML]="documentContent | safeHtml"></div>
        </div>

        <ng-template #noResults>
            <p>{{ 'text.noResultsFound' | translate }}</p>
        </ng-template>
    </ng-template>
</div>
